import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Params, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Constants } from '../../shared/constants';

@Injectable()
export class PaymentGuard implements CanActivate {

  constructor(
    private router: Router,
  ) { }

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let queryParams: Params = next.queryParams;
    let action = queryParams.action;
    let token = queryParams.token ? queryParams.token : localStorage.getItem(Constants.COMMISSION_TOKEN_KEY);

    if (action && token) {
      localStorage.setItem(Constants.COMMISSION_TOKEN_KEY, token);
      return true;
    }

    this.router.navigate(['payment/error']);
    return false;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/service/payment.guard.ts